import { logUtil } from 'packages/src'
import getIdReduxUtil from 'modules/redux/utils/get-id/index.js'
import {
  getByIdMediaSelector,
  getVideoMediaIdByExerciseIdSelector,
  MEDIA_MODEL_KEY
} from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'
import getNameReduxUtil from 'modules/redux/utils/get-name/index.js'
import interpolateRouteUtil from 'modules/routes/utils/interpolate/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import getVideoObjectFromInstanceSchemaUtil from 'modules/schema/utils/get-video-object-from-instance/index.js'
import getDescriptionByIdExerciseSelector from 'modules/exercise/redux/selectors/get-description-by-id/index.js'
import getSlugExerciseNameUtil from 'modules/exercise/utils/get-slug/index.js'

/**
 * @param props
 * @param props.instance
 * @param props.state
 * @param props.intl
 */
const getVideoExerciseSchemaUtil = (props) => {
  const {
    state,
    instance,
    intl
  } = props
  const id = getIdReduxUtil(instance)

  const logPrefix = `id=${id}`
  logUtil('getVideoExerciseSchemaUtil').debug(`${logPrefix} [start]`)

  const mediaId = getVideoMediaIdByExerciseIdSelector(id)(state)
  const media = getByIdMediaSelector(mediaId)(state)
  const posterUrl = getValueReduxUtil(media, MEDIA_MODEL_KEY.THUMBNAIL)
  const videoUrl = getValueReduxUtil(media, MEDIA_MODEL_KEY.URL)
  const slug = getSlugExerciseNameUtil(
    getNameReduxUtil(instance)
  )
  const url = interpolateRouteUtil(
    ROUTE_PATH.VIEW_EXERCISE_SLUG,
    {
      id,
      slug
    }
  )

  const description = getDescriptionByIdExerciseSelector({
    id,
    intl,
    isShort: true
  })(state)

  return getVideoObjectFromInstanceSchemaUtil({
    instance,
    posterUrl,
    videoUrl,
    url,
    description
  })
}

export default getVideoExerciseSchemaUtil
